<template>
<!-- yhub生产配置 -->
  <div class="content">
    <p class="titleP">
      <span>{{ $t('adminView.productInfo') }}</span>
      <span v-if="!isAdd">({{dialogObj.productId}})</span>
    </p>
    <el-form id="productPop" ref="productPop" :model="dialogObj" inline >
      <!-- 归属公司 -->
      <el-form-item :label="'归属公司'" required>
        <el-select v-model="dialogObj.companyId" filterable placeholder="请选择" clearable @change="changeCompany">
          <el-option v-for="item in companyOption" :key="item.companyId" :label="item.companyName"
            :value="item.companyId">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 软硬件版本 -->
      <el-form-item :label="$t('adminView.softHardV')" required>
        <el-cascader v-model="softHardV1" :options="softHardVOptions" @change="softHardVChange" />
        <p v-show="isShowSoftHardVWarning" class="redWarningFont">{{ $t('adminView.enterSoftHardV') }}</p>
      </el-form-item>
      <el-form-item :label="$t('adminView.TargetQTY')" prop="maxProduce" required>
        <el-input-number v-model="dialogObj.maxProduce" :step="1" :min="1" />
      </el-form-item>
      <!-- 使用地区 -->
      <el-form-item :label="$t('dashboard.SiteName')" prop="region" required>
        <el-input v-model="dialogObj.region" />
      </el-form-item>

      <el-form-item :label="$t('adminView.productModel')" prop="productModel" required>
        <el-autocomplete v-model="dialogObj.productModel" class="inline-input" :fetch-suggestions="querySearch"
          :placeholder="$t('warningSet.Pleaseenter')" @select="handleSelect" />
      </el-form-item>

      <!--productModelCustomer： 存放两个新字段 server_selection，telecom_operator -->

      <!-- 电流计类型 -->
      <!-- <el-form-item :label="$t('BondOrUpdateDevice.SensorType')" prop="batteryBrand">
        <el-select v-model="dialogObj.mainCurrentSensorType" :placeholder="$t('button.select')" @input="change($event)"
          @change="changeDiaVal('mainCurrentSensorType')">
          <el-option v-for="item in mainCurrentOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item> -->

      <div>
        <!-- 第二路电压 -->
        <el-form-item :label="$t('adminView.AUXVol')" prop="tempraturePlace">
          <el-radio-group v-model="dialogObj.auxBatteryVoltage" @change="changeAuxVol">
            <el-radio :label="0">{{ $t('adminView.No') }}</el-radio>
            <el-radio :label="1">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 二路电流 -->
        <el-form-item :label="$t('adminView.AUXCurrent')" prop="tempraturePlace">
          <el-radio v-model="dialogObj.auxBatteryCurrent" :label="0"
            @change="changeDiaVal('auxBatteryCurrent')">{{ $t('adminView.No') }}</el-radio>
          <el-radio v-model="dialogObj.auxBatteryCurrent" :label="1"
            @change="changeDiaVal('auxBatteryCurrent')">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
        </el-form-item>
      </div>
      <div>
        <!-- 液位接口 -->
        <el-form-item :label="$t('adminView.LevelSensor')" prop="batteryBrand">
          <el-select v-model="dialogObj.waterLevelSocket" @change="changeDiaVal('waterLevelSocket')">
            <el-option v-for="item in waterLevelOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <!-- 温度计类型 -->
        <el-form-item :label="$t('adminView.TemSensor')" prop="tempraturePlace">
          <el-select v-model="dialogObj.tempraturePlace">
            <el-option v-for="item in tempOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </div>

      <el-form-item label="锁车信号" prop="batteryBrand">
        <el-radio-group v-model="dialogObj.interLockSocket" @change="changeDiaVal('interLockSocket')">
          <el-radio :label="0">{{ $t('adminView.No') }}</el-radio>
          <el-radio :label="1">{{ $t('adminView.NormallyOpen') }}</el-radio>
          <el-radio :label="2">{{ $t('adminView.NormallyClose') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('BondOrUpdateDevice.communication')" prop="rs485Socket">
        <el-radio v-model="dialogObj.rs485Socket" :label="0"
          @change="changeDiaVal('rs485Socket')">{{ $t('adminView.No') }}</el-radio>
        <el-radio v-model="dialogObj.rs485Socket" :label="1"
          @change="changeDiaVal('rs485Socket')">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
      </el-form-item>
      <el-form-item :label="$t('adminView.Ignition')" prop="signalASocket">
        <el-radio v-model="dialogObj.signalASocket" :label="0"
          @change="change($event)">{{ $t('adminView.No') }}</el-radio>
        <el-radio v-model="dialogObj.signalASocket" :label="1"
          @change="change($event)">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
      </el-form-item>
      <el-form-item :label="$t('adminView.Hourmeter')" prop="signalBSocket">
        <el-radio v-model="dialogObj.signalBSocket" :label="0"
          @change="change($event)">{{ $t('adminView.No') }}</el-radio>
        <el-radio v-model="dialogObj.signalBSocket" :label="1"
          @change="change($event)">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
      </el-form-item>

      <el-form-item :label="'二维码内容'">
        <el-radio v-model="dialogObj.qrType" :label="1">url格式（默认）</el-radio>
        <el-radio v-model="dialogObj.qrType" :label="2">SN:xxx格式</el-radio>
      </el-form-item>
      <el-form-item :label="$t('adminView.printProductDate')">
        <el-radio v-model="dialogObj.printMd" :label="0">{{ $t('adminView.no') }}</el-radio>
        <el-radio v-model="dialogObj.printMd" :label="1">{{ $t('adminView.Yes') }}</el-radio>
      </el-form-item>
      <!-- 贴纸备注 -->
      <div>
        <el-form-item :label="$t('adminView.pmcProductId')">
          <el-input v-model="dialogObj.pmcProductId" />
        </el-form-item>
        <el-form-item :label="$t('adminView.PrintNotes')" prop="batteryBrand" class="remarkPop">
          <el-input v-model="dialogObj.labelRemark" :autosize="{ minRows: 2, maxRows: 8}"
            :placeholder="$t('warningSet.Pleaseenter')" type="textarea" />
        </el-form-item>
        <el-form-item :label="$t('warningPage.Remark')" prop="batteryBrand" class="remarkPop">
          <el-input v-model="dialogObj.remark" :autosize="{ minRows: 2, maxRows: 8}"
            :placeholder="$t('warningSet.Pleaseenter')" type="textarea" />
        </el-form-item>
      </div>

      <p class="titleP">
        <span>系统电压</span>
      </p>
      <!-- 输入电压范围 -->

      <el-form-item :label="$t('adminView.LowVoltage')" prop="batteryBrand">
        <el-select v-model="dialogObj.hardwareProtection" :placeholder="$t('button.select')" @change="protectChange">
          <el-option v-for="item in hardwareProOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('adminView.inputRange')" prop="inputRang">
        <el-select v-model="dialogObj.inputRange" :placeholder="$t('button.select')" @change="inputRangeChange">
          <el-option v-for="item in inputRangeOptions" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item :label="'电池系统'" prop="batterySystemVolt">
        <el-input v-model="editBasicinfo.batterySystemVolt" v-Int style="width:200px;" placeholder="12~96"
          @input="change($event)" @change="changeBatteryV" /> V
        <p class="formErrorP">{{ checkIntBet(editBasicinfo.batterySystemVolt,'batterySystemVolt',12,96,1,24) }}
        </p>
      </el-form-item>
      <el-form-item :label="$t('AllDevices.HardwareV')">
        <!--硬件电压等级1：高压版本  其他：非高压版本-->
        <el-radio-group v-model="editBasicinfo.voltClass" @change="voltClassChange">
          <el-radio :label="1"> {{ $t('AllDevices.HighVVersion') }}</el-radio>
          <el-radio :label="2"> {{ $t('AllDevices.NonHighVVersion') }}</el-radio>
        </el-radio-group>

      </el-form-item>
    </el-form>

    <!-- 配置信息 -->
    <p class="titleP">
      <span>配置方案</span>
    </p>
    <el-form id="configPop" ref="configPop" inline :model="editBasicinfo" style="padding-top: 15px;">
      <p v-if="!isAdd && noConfig" class="noConfigP">[{{ $t('adminView.defaultConfig') }}]</p>

      <el-form-item :label="'电池型号'" required>
        <!-- {{batteryCascader}} -->
        <el-cascader v-model="batteryCascader" :options="options2" @change="batteryModelChange" />
        <p v-show="isShowBatteryModelWarning" class="redWarningFont"> {{ $t('BondOrUpdateDevice.SelectBattery') }}
        </p>
      </el-form-item>

      <el-form-item :label="$t('BondOrUpdateDevice.Capacity')" prop="batteryTotalah">
        <el-input v-model="editBasicinfo.batteryTotalah" v-Int style="width:100px;" placeholder="1~1000"
          @change="changeBatteryAh" /> AH
      </el-form-item>

      <el-form-item :label="$t('AllDevices.cellNumber')" prop="cell">
        <el-input v-model="editBasicinfo.cell" v-Int placeholder="1~100" style="width: 60px;" />
      </el-form-item>
      <el-form-item :label="$t('AllDevices.Type')">
        <el-radio-group v-model="editBasicinfo.nominalCapacity" @change="changeEditC520">
          <el-radio :label="2">C5</el-radio>
          <el-radio :label="3">C6</el-radio>
          <el-radio :label="1">C20</el-radio>
        </el-radio-group>
      </el-form-item>

      <div>
        <el-form-item :label="$t('BondOrUpdateDevice.SensorType')">
          <!--电流计类型-->
          <el-radio-group v-model="editBasicinfo.sensorType" @change="sensorTypeChange">
            <el-radio :label="2">SHUNT</el-radio>
            <el-radio :label="1">HALL</el-radio>
          </el-radio-group>
          <!-- 正反向 -->
          <el-radio v-model="editBasicinfo.hallDirection" :label="1">{{ $t('BondOrUpdateDevice.Forward') }}</el-radio>
          <el-radio v-model="editBasicinfo.hallDirection" :label="2">{{ $t('BondOrUpdateDevice.Reverse') }}</el-radio>

          <el-select v-model="editBasicinfo.hallSensorRange" class="hallSensorRange" @change="hallSensorRangeChange">
            <el-option v-for="item in sensorRangeOptions" v-show="item.show" :key="item.key" :label="item.label"
              :value="item.key" />
          </el-select>
        </el-form-item>
      </div>
      <div>
        <!--采样算法-->
        <el-form-item :label="$t('AllDevices.SampAlgorithm')">

          <el-radio v-model="editBasicinfo.samplingMode" :label="1" @change="samplingModeChange($event)">
            {{ $t('AllDevices.DynamicSamp') }}</el-radio>
          <el-radio v-model="editBasicinfo.samplingMode" :label="2" @change="samplingModeChange($event)">
            {{ $t('AllDevices.StaticSampling') }}</el-radio>

          <template v-if="editBasicinfo.samplingMode==1">
            <el-input v-model.trim="editBasicinfo.voltChangeRate" type="text" style="width: auto;" />
            <span style="margin-right:30px;">mV</span>
            <p class="formErrorP">
              {{ checkIntBet(editBasicinfo.voltChangeRate,'voltChangeRate',100,1000,editBasicinfo.samplingMode==1?1:0,300) }}
            </p>
          </template>
          <template v-if="editBasicinfo.samplingMode==2">
            <el-input v-model.trim="editBasicinfo.samplingRate" type="text" style="width: auto;" />
            <span>{{ $t('dataAndTime.Second') }}</span>
            <p class="formErrorP">
              {{ checkIntBet(editBasicinfo.samplingRate,'voltChangeRate',6,600,editBasicinfo.samplingMode==2?1:0,480) }}
            </p>
          </template>

        </el-form-item>
      </div>

      <el-form-item v-if="softHardType==1" :label="$t('AllDevices.GPSFunction')">
        <!--GPS功能-->
        <el-radio v-model="editBasicinfo.gpsFunction" :label="1">
          {{ $t('AllDevices.FullyTurnOnGPS') }}</el-radio>
        <el-radio v-model="editBasicinfo.gpsFunction" :label="2">
          {{ $t('AllDevices.TurnOffGPS') }}</el-radio>
      </el-form-item>
      <el-form-item v-if="softHardType==1 && editBasicinfo.gpsFunction==1" :label="$t('adminView.showPosition')">
        <!--定位展示-->
        <el-switch v-model="editBasicinfo.locationStatus" :active-text="$t('location.enable')"
          :inactive-text="$t('location.disable')" />
      </el-form-item>

      <div>
        <el-form-item :label="'CAN'" prop="canFuntion">
          <el-select v-model="editBasicinfo.canFuntion" :placeholder="$t('button.select')" @input="change($event)">
            <el-option v-for="item in canOptions" :key="item.code" :label="item.code + ' ' + item.des"
              :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('BondOrUpdateDevice.canopenBaudrate')">
          <el-radio v-model="editBasicinfo.canopenBaudrate" :label="1" @change="change">125K</el-radio>
          <el-radio v-model="editBasicinfo.canopenBaudrate" :label="2" @change="change">250K</el-radio>
          <el-radio v-model="editBasicinfo.canopenBaudrate" :label="3" @change="change">500K</el-radio>
        </el-form-item>
        <el-form-item :label="$t('BondOrUpdateDevice.NodeID')" prop="nodeID">
          <el-input-number v-model="editBasicinfo.nodeID" v-Int placeholder="1~127" :step="1" @change="change" />
          <p class="formErrorP">{{ checkIntBet(editBasicinfo.nodeID,'nodeID',1,127,1,85) }}</p>
        </el-form-item>
      </div>
      <el-form-item :label="$t('BondOrUpdateDevice.LEDIndicator')">
        <!--面板指示灯-->
        <el-radio v-model="editBasicinfo.ledSetting" :label="1">
          {{ $t('location.enable') }}</el-radio>
        <el-radio v-model="editBasicinfo.ledSetting" :label="2">
          {{ $t('location.disable') }}</el-radio>
      </el-form-item>
      <el-form-item :label="$t('BondOrUpdateDevice.Track')">
        <!--运动轨迹-->
        <el-switch v-model="editBasicinfo.moveOrbitSwitch">
        </el-switch>
        <template v-if="editBasicinfo.moveOrbitSwitch">
          <el-input-number v-model="editBasicinfo.locationSample" size="medium" step-strictly :step="1" type="small"
            :min="30" :max="360" />
          <!-- <p class="formErrorP">
            {{ checkIntBet(editBasicinfo.locationSample,'locationSample',30,3600,editBasicinfo.moveOrbitSwitch?1:0,60) }}
          </p> -->
          <span>{{ $t('BondOrUpdateDevice.SecondsTimes') }}</span>
        </template>
      </el-form-item>
      <el-form-item :label="$t('allDeviceDetail.RemainingTime')" prop="showAvailableTime">
        <el-switch v-model="editBasicinfo.showAvailableTime" :active-text="$t('location.enable')"
          :inactive-text="$t('location.disable')" @change="change($event)" />
      </el-form-item>
      <el-form-item :label="$t('AllDevices.IgnitionReport')" prop="hourMeterStatus">
        <el-switch v-model="editBasicinfo.hourMeterStatus" :active-text="$t('location.enable')"
          :inactive-text="$t('location.disable')" @change="switchhourMeterStatus($event)" />
      </el-form-item>
      <el-form-item v-show="editBasicinfo.hourMeterStatus" :label="$t('AllDevices.IgnitionVoltage')"
        prop="hourMeterStatus">
        <el-input v-model="editBasicinfo.openIgnitionVol" placeholder="0.5~60" style="width:200px;"
          @input="change($event)" /> V
        <p class="formErrorP">
          {{ checkDigitBet(editBasicinfo.openIgnitionVol,'openIgnitionVol',0.5,60,editBasicinfo.hourMeterStatus&&softHardType!=3,0.5) }}
        </p>
      </el-form-item>
      <el-form-item v-show="editBasicinfo.hourMeterStatus" :label="$t('AllDevices.UseVoltageTh')"
        prop="hourMeterStatus">
        <el-input v-model="editBasicinfo.workHourmeterVol" placeholder="0.5~60" style="width:200px;"
          @input="change($event)" /> V
        <p class="formErrorP">
          {{ checkDigitBet(editBasicinfo.workHourmeterVol,'workHourmeterVol',0.5,60,editBasicinfo.hourMeterStatus&&softHardType!=3,7) }}
        </p>
      </el-form-item>

      <p class="titleP">
        <span>网络配置</span>
      </p>
      <!-- 网卡型号 -->
      <el-form-item :label="$t('adminView.networkModule2')" prop="batteryBrand">
        <el-select v-model="dialogObj.netModule" :placeholder="$t('button.select')">
          <el-option v-for="item in netModuleOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="dialogObj.netModule" :label="$t('adminView.AntennaInstallation')" prop="antennaPlace">
        <el-select v-model="dialogObj.antennaPlace" :placeholder="$t('button.select')" @input="change($event)">
          <el-option v-for="item in antennaPlaceOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <div>
        <el-form-item v-if="dialogObj.netModule" :label="$t('sideBar.SIM')">
          <el-radio-group v-model="dialogObj.provideSim" @change="editBasicinfo.gprsApnName = ''">
            <el-radio :label="1">{{ $t('adminView.GPDProvides') }}</el-radio>
            <el-radio :label="0">{{ $t('adminView.prepared') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="APN" prop="gprsApnName" required>
          <el-select v-model="editBasicinfo.gprsApnName" @change="changeApn">
            <el-option v-for="item in apnOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
      </div>

      <!--网络功能-->
      <!-- <el-form-item v-if="softHardType==1" :label="$t('AllDevices.NetFeatures')">
        <el-radio v-model="editBasicinfo.netFunction" :label="1" @change="change($event)">
          {{ $t('AllDevices.FullyOpenNet') }}</el-radio>
        <el-radio v-model="editBasicinfo.netFunction" :label="2" :disabled="true" @change="change($event)">
          {{ $t('AllDevices.StartNetOnce') }}</el-radio>
        <el-radio v-model="editBasicinfo.netFunction" :label="3" :disabled="true" @change="change($event)">
          {{ $t('AllDevices.StartNet2h') }}</el-radio>
      </el-form-item> -->

      <el-form-item label="服务器选择">
        <el-radio-group v-model="serverSelection">
          <el-radio :label="1">阿里云（香港）</el-radio>
          <el-radio :label="2">谷歌云（比利时）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="默认电信运营商（与使用地区有关）">
        <!-- {{teleDefa}} -->
        <el-cascader v-model="teleDefa" :options="teleOptions" @change="teleChange"></el-cascader>
      </el-form-item>
    </el-form>
    <p class="titleP ">
      <span>警告配置</span>
      <i class="click" style="font-size: 14px;" @click="dialogVisible = true">(点击查看)</i>
    </p>

    <el-dialog title="默认警告方案" :visible.sync="dialogVisible">
      <!-- 警告信息 -->
      <el-form>
        <el-form-item :label="$t('warningSet.AlarmSwitch')">
          <span style="color: #F49530;margin-left: 10px;">{{ $t('warningSet.openTotalWarn') }}</span>
          <el-switch v-model="warnSetInfo.warningOpen" :active-value="'1'" :inactive-value="'0'"></el-switch>
        </el-form-item>

        <template v-if="warnSetInfo.warningOpen == '1'">
          <div class="itemBox">
            <label>
              <el-checkbox v-model="warnSetInfo.socSwitch" :true-label="1" :false-label="0"
                @change="changeSocChecked" />
              SOC警告
            </label>
            <span>SOC过低警告值</span>
            <el-input-number v-model="warnSetInfo.minSoc" placeholder="0~100" :step="1" :max="100" :min="1" />
            <span>过低警告恢复值</span>
            <el-input-number v-model="warnSetInfo.maxSoc" placeholder="0~100" :step="1" :max="100" :min="1" />
          </div>
          <div class="itemBox">
            <label>
              <el-checkbox v-model="warnSetInfo.tempSwitch" :true-label="1" :false-label="0" @change="changTemSwitch" />
              <span>{{ $t('basicinfo.AbnormalTemperature') }}</span>
            </label>
            <template v-if="warnSetInfo.tempSwitch == 1">
              <div class="attrDiv">
                <span>{{ $t('warningSet.lowTemperature') }}({{ temUnit() }})</span>
                <el-input-number v-model="warnSetInfo.minTemp" placeholder="-40~125" :step="1" />
              </div>
              <div class="attrDiv">
                <span>{{ $t('warningSet.HighTemperature') }}({{ temUnit() }})</span>
                <el-input-number v-model="warnSetInfo.maxTemp" placeholder="0~125" :step="1" />

                <span>{{ $t('warningSet.HighTemperature2') }}({{ temUnit() }})</span>
                <el-input-number v-model="warnSetInfo.maxTemp2" placeholder="0~125" :step="1" />
                <br />
                <span>{{ $t('warningSet.HighTemperature3') }}({{ temUnit() }})</span>
                <el-input-number v-model="warnSetInfo.maxTemp3" placeholder="0~125" :step="1" />

              </div>
              <div class="attrDiv">
                <span>{{ $t('warningSet.temError') }}({{ temUnit() }})</span>
                <el-input-number v-model="warnSetInfo.errTemp" placeholder="0~125" :step="1" />

              </div>
            </template>
          </div>
          <!-- 电压异常/低压保护 -->
          <div class="itemBox">
            <div class="labelDiv">
              <label>
                <el-checkbox v-model="voltChecked" @change="changeVolCheck" />
                <span>{{ $t('warningSet.abnormalV') }}</span>
              </label>
              <label>
                <el-checkbox v-model="volProtectChecked" @change="changeVolCheck" />
                <span>{{ $t('warningSet.LowVoltageProtection') }}</span>
              </label>
            </div>
            <div v-if="voltChecked" class="attrDiv">
              <span>{{ $t('warningSet.hightVoltage') }}(V)</span>
              <el-input-number v-model="warnSetInfo.maxV" placeholder="5~120" :step="1" @change="change($event)" />
              <p class="formErrorP">{{ checkDigitBet(warnSetInfo.maxV,'maxV',5,120,voltChecked,1.48) }}</p>
            </div>
            <div v-if="voltChecked||volProtectChecked" class="attrDiv">
              <span>{{ $t('warningSet.lowVoltage') }}(V)</span>
              <el-input-number v-model="warnSetInfo.minV" placeholder="5~120" :step="1" />

              <span>{{ $t('warningSet.lowVoltage2') }}(V)</span>
              <el-input-number v-model="warnSetInfo.lowVolLevel2" placeholder="5~120" :step="1" />
              <br />
              <span>{{ $t('warningSet.lowVoltage3') }}(V)</span>
              <el-input-number v-model="warnSetInfo.lowVolLevel3" placeholder="5~120" :step="1" />

              <span>{{ $t('warningSet.recoveryVoltage') }}(V)</span>
              <el-input-number v-model="warnSetInfo.recoveryVoltage" placeholder="5~120" :step="1" />
              <br />
              <span>{{ $t('warningSet.AlarmDuration') }}({{ $t('dataAndTime.Seconds') }})</span>
              <el-input-number v-model="warnSetInfo.voltageDuration" placeholder="5~7200" :step="1" />

            </div>
          </div>

          <div v-if="softHardType!=2" class="item_box">
            <div>
              <el-checkbox v-model="netChecked" @change="changeNetChecked" />
              <span class="label">{{ $t('warningInfo.NetworkAbnormal') }}</span>
            </div>
            <div>
              <span>{{ $t('warningSet.AlarmDuration') }}({{ $t('dataAndTime.Hours') }})</span>
              <el-input-number v-model="warnSetInfo.offLine" v-Int placeholder="1~10000" :step="1"
                @change="change($event)" />
              <p class="formErrorP">{{ checkIntBet(warnSetInfo.offLine,'offLine',1,10000,netChecked,168) }}</p>
            </div>
          </div>
          <!-- 半电压不平衡 -->
          <div class="itemBox" v-if="editBasicinfo.auxVoltageSupport">
            <div class="labelDiv">
              <el-checkbox v-model="halfvChecked" @change="changeHalfvSwitch" />
              <span class="label">{{ $t('warningInfo.HalfVWarnS') }}</span>
            </div>
            <div class="attrDiv">
              <span>{{ $t('warningSet.HalfVThreshold') }}(mV)</span>
              <el-input-number v-model="warnSetInfo.halfVol" placeholder="10~10000" :step="1"
                @change="change($event)" />
              <p class="formErrorP">
                {{ checkIntBet(warnSetInfo.halfVol,'halfVol',10,10000,(halfvChecked&&editBasicinfo.halfV)?1:0,10) }}
              </p>
            </div>
            <div class="attrDiv">
              <span>{{ $t('warningSet.AlarmDuration') }}({{ $t('dataAndTime.Seconds') }})</span>
              <el-input-number v-model="warnSetInfo.halfVoltageDuration" v-Int placeholder="5~7200" :step="1"
                @change="change($event)" />
              <p class="formErrorP">
                {{ checkIntBet(warnSetInfo.halfVoltageDuration,'halfVoltageDuration',5,7200,(halfvChecked&&editBasicinfo.halfV)?1:0,15) }}
              </p>
            </div>
          </div>
          <div class="item_box">
            <el-checkbox v-model="waterChecked" @change="changeWaterSwitch" />
            <span class="label">{{ $t('warningSet.LevelWarning') }}</span>
            <span>{{ $t('warningSet.AlarmDuration') }}({{ $t('dataAndTime.Mins') }})</span>
            <el-input-number v-model="warnSetInfo.waterDuration" placeholder="1~10000" :step="1"
              @change="change($event)" />
            <p class="formErrorP">
              {{ checkIntBet(warnSetInfo.waterDuration,'waterDuration',1,10000,waterChecked,30) }}
            </p>
          </div>
          <!-- 电流警告 -->
          <div class="itemBox">
            <div class="labelDiv">
              <label>
                <el-checkbox v-model="warnSetInfo.chargeCurrentSwitch" @change="changeChargeCurrent" />
                <span>{{ $t('warningSet.chargingOvercurrent') }}</span>
              </label>
              <label>
                <el-checkbox v-model="warnSetInfo.dischargeCurrentSwitch" @change="changeDischargeCurrent" />
                <span>{{ $t('warningSet.dischargeOvercurrent') }}</span>
              </label>
            </div>
            <div v-if="warnSetInfo.chargeCurrentSwitch==1" class="attrDiv">
              <span>{{ $t('warningSet.chargingOvercurrent') }}(A)</span>
              <el-input-number v-model="warnSetInfo.chargeCurrent" v-Int placeholder="1~1000" :step="1"
                @change="change($event)" />
              <p class="formErrorP">
                {{ checkIntBet(warnSetInfo.chargeCurrent,'chargeCurrent',1,1000,(warnSetInfo.chargeCurrentSwitch==1)?1:0,editBasicinfo.batteryTotalah) }}
              </p>
            </div>
            <div v-if="warnSetInfo.dischargeCurrentSwitch==1" class="attrDiv">
              <span>{{ $t('warningSet.dischargeOvercurrent') }}(A)</span>
              <el-input-number v-model="warnSetInfo.dischargeCurrent" v-Int placeholder="1~1000" :step="1"
                @change="change($event)" />
              <p class="formErrorP">
                {{ checkIntBet(warnSetInfo.dischargeCurrent,'dischargeCurrent',1,1000,(warnSetInfo.dischargeCurrentSwitch==1)?1:0,editBasicinfo.batteryTotalah*2) }}
              </p>
            </div>
            <div v-if="warnSetInfo.chargeCurrentSwitch==1||warnSetInfo.dischargeCurrentSwitch==1" class="attrDiv">
              <span>{{ $t('warningSet.AlarmDuration') }}({{ $t('dataAndTime.Seconds') }})</span>
              <el-input-number v-model="warnSetInfo.currentDuration" v-Int placeholder="5~7200" :step="1"
                @change="change($event)" />
              <p class="formErrorP">
                {{ checkIntBet(warnSetInfo.currentDuration,'currentDuration',5,7200,(warnSetInfo.chargeCurrentSwitch==1||warnSetInfo.dischargeCurrentSwitch==1)?1:0,15) }}
              </p>
            </div>
          </div>

          <div class="item_box">
            <el-checkbox v-model="linchongChecked" @change="changeLinchongSwitch" />
            <span>{{ $t('warningSet.charging_limit') }}</span>
            <span>{{ $t('warningSet.times_greater') }}</span>
            <el-input-number v-model="warnSetInfo.intermediateChargeTimes" v-Int placeholder="5~1000" :step="1"
              @change="change($event)" />
            <p class="formErrorP">
              {{ checkIntBet(warnSetInfo.intermediateChargeTimes,'intermediateChargeTimes',5,1000,linchongChecked,10) }}
            </p>
          </div>
          <div class="item_box">
            <el-checkbox v-model="chargeDisChecked" @change="changeChargeDisCheckedSwitch" />
            <span class="label">{{ $t('warningSet.chargeDisWarn') }}</span>
            <span>{{ $t('warningSet.chargeDisWarnVal') }}(%)</span>
            <el-input-number v-model="warnSetInfo.chargingDischargingRateValue" v-Int placeholder="120~10000" :step="1"
              @change="change($event)" />
            <p class="formErrorP">
              {{ checkIntBet(warnSetInfo.chargingDischargingRateValue,'chargingDischargingRateValue',120,10000,chargeDisChecked,200) }}
            </p>
          </div>
          <!-- 车辆周期维护 -->
          <!-- <div class="item_box">
            <el-checkbox v-model="cheliangChecked" />
            <span class="item_label">{{ $t('warningSet.periodic_vehicles') }}</span>
            <span>{{ $t('warningSet.every_month_1') }} </span>
            <el-select v-model="warnSetInfo.vehicleMaintenanceDay" style="width:140px;">
              <el-option v-for="item in 28" :key="item" :label="item" :value="item" />
            </el-select>
            <span>{{ $t('warningSet.every_month_2') }}</span>
          </div> -->
          <!--电池 维护方式 -->
          <!-- <div class="item_box">
            <el-checkbox v-model="dianchiChecked" @change="changeDianchiSwitch" />
            <span class="item_label">{{ $t('warningSet.battery_maint') }}</span>
            <el-select v-model="warnSetInfo.batteryMaintenanceType" style="width:120px;" @change="changeDianchiSwitch">
              <el-option v-for="item in batteryMainOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <template v-if="warnSetInfo.batteryMaintenanceType==1">
              <span>{{ $t('warningSet.every_month_1') }} </span>
              <el-select v-model="dianchiVal1" style="width:100px;">
                <el-option v-for="item in 28" :key="item" :label="item" :value="item" />
              </el-select>
              <span>{{ $t('warningSet.every_month_2') }}</span>
            </template>
            <template v-if="warnSetInfo.batteryMaintenanceType==2">
              <span class="item_label">{{ $t('warningSet.per_charge_1') }}(AH)</span>
              <el-input-number v-model="dianchiVal2" v-Int :placeholder="'1~'+Number(editBasicinfo.batteryTotalah)*100"
                :step="1" :min="50" @change="change($event)" />
              <p class="formErrorP">
                {{ checkIntBet(dianchiVal2,'dianchiVal2',1,Number(editBasicinfo.batteryTotalah)*100,(dianchiChecked&&warnSetInfo.batteryMaintenanceType==2)?1:0,Number(editBasicinfo.batteryTotalah)*10) }}
              </p>
            </template>
          </div> -->

          <!-- 订阅消息 -->
          <!-- <div class="item_box">
            <span class="item_label">订阅消息类型</span>
            <el-select v-model="statusSwitches" multiple :placeholder="$t('button.select')" style="width: 290px;">
              <el-option v-for="item in subNewsOptions" :key="item.key" :label="$t(item.label)" :value="item.key" />
            </el-select>
          </div> -->
        </template>
      </el-form>
    </el-dialog>
    <div style="margin-top: 30px;">
      <el-button @click="goBack">{{ $t('button.Cancel') }}</el-button>
      <el-button type="primary" @click="submitPop">{{ isAdd? '新建': '保存' }}</el-button>
      <el-button v-if="!isAdd" type="primary" @click="submitPop(1)">新建同款</el-button>
    </div>
  </div>
</template>

<script>
import { add, updateById, listDeviceVersion } from '@/api/product'
import { apnList, cascader, canFunctionList } from '@/api/allDevice'

import { prodModels } from './selectOptions'
import { mapState } from 'vuex'
import telecomOperators from './telecomOperators'
import SelectComp from '@/components/SelectComp.vue'
// const currentDate = new Date();
// const year = currentDate.getFullYear();
// const month = currentDate.getMonth() + 1; // 月份是从 0 开始计数的，因此要加1
// const day = currentDate.getDate();
// const add0 = (m) => { return m < 10 ? '0' + m : m };
// const configName = 'product_order_' + year + add0(month) + add0(day)
export default {
  components: { SelectComp },
  data () {
    return {
      isAdd: false,
      batteryCascader: [],
      batteryModelObj: {},
      batteryArr: [],
      options2: [],
      activeTab: 'config',
      isShowBatteryModelWarning: false,
      
      canOptions: [],
      apnOptions: [],
      // isShowHallDetail: false,
      isShowMustIntWarn: false,
      sensorRangeOptions: [
        { key: 1, label: '300A', show: true },
        { key: 3, label: '750A', show: false },
        { key: 2, label: '800A', show: true }
      ],
      dialogObj: {
        maxProduce: '',
        nowProduce: 0,
        auxBatteryVoltage: 1,
        auxBatteryCurrent: 0,
        hardwareProtection: 2,
        interLockSocket: 0,
        canSocket: 1,
        waterLevelSocket: 2,
        antennaPlace: 2,
        antennaType: 0,
        rs485Socket: 0,
        signalASocket: 0,
        signalBSocket: 0,
        tempraturePlace: 2,
        mainCurrentSensorType: 1,
        secondCurrentSensorType: 1,
        netModule: 'EC25-AU',
        inputRange: '24 to 60 VDC',
        provideSim: 1,
        ownCompany: 'GPD_ADMIN',
        companyId: '',
        labelRemark: 'High Voltage',
        region: '',
        remark: '',
        status: 0,
        printMd: 1,
        qrType: 1,
        productModel: '',
        yhubConfigAdmin: {},
        productModelCustomer: ''
      },
      editBasicinfo: {
        auxCurrentSupport: false,
        auxVoltageSupport: true,
        batteryId: 1,
        batteryTotalah: 300,
        batteryBrand: '',
        batteryModel: ' ',
        batterySystemVolt: 24,
        canFuntion: 0,
        configFrom: 201,
        configTime: '',
        configVersion: 1,
        extralFuntion: 0,
        moveOrbitSwitch: false,
        communication485: false,
        gprsApnName: 'ctm-mobile',
        hallDirection: 1,
        hallSensorRange: 1,
        sensorType: 1,
        supportRelaycontrol: 0,
        supportWaterlevel: 1,
        ledSetting: 1,
        locationSample: 60,
        samplingMode: 1,
        voltChangeRate: 300,
        samplingRate: 480,
        gpsFunction: 1,
        netFunction: 1,
        voltClass: 1,
        // configName: configName,
        id: null,
        nominalCapacity: 1,
        halfV: false,
        locationOrNot: false,
        cell: 1,
        showAvailableTime: false,
        hourMeterStatus: false,
        openIgnitionVol: 0.5,
        workHourmeterVol: 7,
        status: null,
        canopenBaudrate: 2,
        nodeID: 85,
        usageSettings: [],
        fullChargeTime: 30,
        locationStatus: true
      },
      noConfig: false,
      inputRangeOptions: ['12 to 72 VDC', '24 to 120 VDC'],

      warnSetInfo: {
        halfVShow: true,
        waterLevelShow: true,
        minSoc: 30,
        maxSoc: 80,
        minTemp: 0,
        maxTemp: 50,
        maxTemp2: 55,
        maxTemp3: 60,
        errTemp: 101,
        minVvalue: 30,
        minV: 22, // 百分比
        lowVolLevel2: 20,
        lowVolLevel3: 18,
        recoveryVoltage: 24,
        maxVvalue: 30,
        maxV: 100,
        voltageDuration: 15,
        halfV: 0,
        supportWaterLevel: '0',
        waterDuration: 5,
        offLineRadio: '1',
        offLine: 168,
        warningOpen: '1',
        chargeCurrentSwitch: true,
        dischargeCurrentSwitch: true,
        chargeCurrent: 100,
        dischargeCurrent: 100,
        currentDuration: 15,
        intermediateChargeTimes: 10,
        chargingDischargingRateValue: 200,
        vehicleMaintenanceSwitch: 0,
        batteryMaintenanceSwitch: 0,
        vehicleMaintenanceDay: 1,
        batteryMaintenanceType: 1,
        socSwitch: 1,
        tempSwitch: 1,
        voltageSwitch: 1,
        netSwitch: 1,
        fullChargeRequestSwitch: 1,
        chargingDischargingRateSwitch: 1,
        halfVoltageDuration: 15,
        halfVol: 0
      },
      vEnterWrong1: false,
      vEnterWrongP1: '',
      vEnterWrong2: false,
      vEnterWrongP2: '',
      vEnterWrong3: false,
      vEnterWrongP3: '',
      lvp: { // 低压保护
        switch: false,
        lv1: '',
        lv2: '',
        lv3: '',
        recover: ''
      },
      noNetModule: false,
      softHardV1: [],
      softHardVOptions: [],
      isShowLocationSampleWarn: false,
      notEdit: false,
      // socChecked: true,
      // temChecked: true,
      voltChecked: true,
      volProtectChecked: false,
      halfvChecked: false,
      netChecked: true,
      waterChecked: false,
      startChecked: false,
      fullChecked: false,
      usingChecked: false,
      statusSwitches: [1, 2, 3],
      users: [],
      checkKeyList: [],
      checkLabelList: [],
      showAll: false,
      dialogVisible: false,
      isAddConfig: false, // 没有一个方案，需要新增
      lastConfig: {
        status: '',
        configFrom: '',
        configTime: ''
      },
      lastOne: {
        config_time: ''
      },
      linchongChecked: true,
      chargeDisChecked: true,
      cheliangChecked: false,
      dianchiChecked: false,
      dianchiVal1: 1, // 电池维护 周期性维护每月几号
      dianchiVal2: 0, // 电池维护 每充容量
      siteList: [],
      canopenBaudrateOptions: [
        { value: 1, label: '125K' },
        { value: 2, label: '250K' },
        { value: 3, label: '500K' }
      ],
      // oldWarnConfig: {}, // 进入编辑页时，设备带入的警告配置

      initProObj: {}, // 初始订单信息form值：来自api，如果api没返回则来自默认值
      initSetObj: {}, // 初始配置信息form值：来自api，如果api没返回则来自默认值
      initWarningSettings: {}, // 初始warningSettings值：来自设备 api，如果api没返回则来自默认值
      checkObj: {},
      checkVal1: ['maxProduce', 'nowProduce'], // 'fullChargeTime',
      checkVal2: ['batteryTotalah', 'batterySystemVolt', 'locationSample', 'voltChangeRate', 'samplingRate', 'cell', 'nodeID', 'openIgnitionVol', 'workHourmeterVol'],
      checkVal3: ['minSoc', 'maxSoc', 'errTemp', 'minTemp', 'maxTemp', 'maxTemp2', 'maxTemp3', 'maxV',
        'minV', 'lowVolLevel2', 'lowVolLevel3', 'recoveryVoltage', 'voltageDuration', 'offLine',
        'chargeCurrent', 'dischargeCurrent', 'currentDuration', 'intermediateChargeTimes', 'halfVol', 'halfVoltageDuration', 'waterDuration',
        'chargingDischargingRateValue'],
      isShowSoftHardVWarning: false,
      serverSelection: 1,
      teleOptions: [],
      telecomOperator: '50502',
      teleDefa: ["61", "50502"]
    }
  },
  computed: {
    ...mapState(['companyOption']),
    
    waterLevelOptions () {
      return [
        { value: 0, label: this.$t('adminView.No') },
        { value: 1, label: this.$t('adminView.Bayonet') },
        { value: 2, label: this.$t('adminView.Drillhole') },
        { value: 3, label: this.$t('adminView.WaterFillCover') }
      ]
    },
    tempOptions () {
      return [
        { value: 0, label: this.$t('adminView.No') },
        { value: 1, label: this.$t('adminView.NegativePost') },
        { value: 2, label: this.$t('adminView.Separated') }
      ]
    },
    statusOptions () { // 当前最新状态：1.审核中、2.生产中、3仓库中、4已发货、5已收货
      return [
        { value: 1, label: this.$t('adminView.underReview') },
        { value: 2, label: this.$t('adminView.inProduction') },
        { value: 3, label: this.$t('adminView.InWarehouse') },
        { value: 4, label: this.$t('adminView.Shipped') },
        { value: 5, label: this.$t('adminView.received') }
      ]
    },
    netModuleOptions () {
      return [
        { value: 'EC25-AU', label: 'EC25-AU' },
        { value: 'EC25-EUX', label: 'EC25-EUX' },
        { value: 'EC25-AF', label: 'EC25-AF' },
        { value: 'EC20-EA', label: 'EC20-EA' },
        { value: 'EC25-J', label: 'EC25-J' },
        { value: 'M5700', label: 'M5700' },
        { value: '', label: this.$t('adminView.No') }
      ]
    },
    // mainCurrentOptions () {
    //   return [
    //     { value: 0, label: this.$t('adminView.No') },
    //     { value: 1, label: this.$t('adminView.Hall300') },
    //     { value: 2, label: this.$t('adminView.Hall800') },
    //     { value: 3, label: this.$t('adminView.Shunt300') },
    //     { value: 4, label: this.$t('adminView.Shunt300').replace('300', 750) }
    //   ]
    // },
    antennaPlaceOptions () {
      return [
        { value: 0, label: this.$t('adminView.No') },
        { value: 1, label: this.$t('adminView.External4G') },
        { value: 2, label: this.$t('adminView.External4GGPS') },
        { value: 3, label: this.$t('adminView.Internal4G') },
        { value: 4, label: this.$t('adminView.Internal4GGPS') }
      ]
    },
    hardwareProOptions () {
      return [
        { value: 1, label: this.$t('adminView.system12') },
        { value: 2, label: this.$t('adminView.system24') }
      ]
    },
    batteryMainOptions () { // 电池维护
      return [
        { value: 1, label: this.$t('warningSet.periodic_maint') },
        { value: 2, label: this.$t('warningSet.capacity_maint') }
      ]
    },
    subNewsOptions () { // 订阅消息
      return [
        { key: 1, label: 'warningSet.StartCharge' },
        { key: 2, label: 'warningSet.full' },
        { key: 3, label: 'warningSet.DisCharging' }
      ]
    },
    softHardType () { // 硬件型号
      if (this.softHardV1 && this.softHardV1.length > 0) {
        if (this.softHardV1[0] == 'YHUB') return 1
        if (this.softHardV1[0] == 'YhubLite') return 2
        if (this.softHardV1[0] == 'DTU') return 3
        return 1
      } else {
        return 1
      }
    }
  },
  mounted () {
    this.initOption()// 电池型号/品牌/设备类型--下拉框初始化
    this._canFunctionList()
    this.getSoftHardV()// 获取软硬件版本

    const pStr = sessionStorage.getItem('admin_product_item')
    // console.log(pStr)
    if (pStr != 'null') {
      this.isAdd = false
      const produceOrder = JSON.parse(pStr)
      console.log('编辑', produceOrder)
      // console.log('订单信息：', produceOrder)
      this.dialogObj = produceOrder
      if (produceOrder.yhubConfigAdmin) {
        this.editBasicinfo = produceOrder.yhubConfigAdmin
        this.editBasicinfo.samplingRate = parseInt(this.editBasicinfo.samplingRate / 1000)
        this.warnSetInfo = JSON.parse(produceOrder.yhubConfigAdmin.warningSettings || '{}')
        this.correctValue()
        this.warnDataFn()
      }
      if (this.dialogObj.productModelCustomer && this.dialogObj.productModelCustomer.indexOf('{') >= 0) {
        const obj = JSON.parse(this.dialogObj.productModelCustomer)
        this.serverSelection = obj.serverSelection
        this.telecomOperator = obj.telecomOperator
      }

    } else {
      console.log('新增')
      this.isAdd = true

    }

    this.initTeleOptions()
  },
  methods: {
    protectChange (val) {
      if (val == 1) {
        this.dialogObj.inputRange = this.inputRangeOptions[0]
        this.editBasicinfo.batterySystemVolt = 12
      }
      if (val == 2) {
        this.dialogObj.inputRange = this.inputRangeOptions[1]
        this.editBasicinfo.batterySystemVolt = 24
      }
    },
    voltClassChange (val) {
      if (val == 1) this.dialogObj.labelRemark = 'High Voltage'
      if (val == 2) this.dialogObj.labelRemark = 'Low Voltage'
    },
    inputRangeChange (val) {
      console.log('电压范围', val)

    },
    teleChange (val) {
      console.log(val)
      this.telecomOperator = val[1]
    },
    initTeleOptions () {
      console.log(telecomOperators)
      const countrys = []
      telecomOperators.forEach(item => {
        countrys.push(item.country)
      })
      const uniqueArr = Array.from(new Set(countrys));
      // console.log(uniqueArr)
      const data = []
      // this.columns[0] = uniqueArr
      uniqueArr.forEach(item => {
        const arr = []
        let code = 0
        telecomOperators.forEach(it => {
          if (it.country == item) {
            code = it.countryCode
            arr.push({
              label: it.network + '(' + it.mnc + ')',
              value: it.mcc + it.mnc
            })
          }
        })
        // this.columnData.push(arr)
        data.push({
          label: item,
          value: code,
          children: arr
        })

      })
      this.teleOptions = data
      this.initTe()
      // this.columns.push(data)
      // this.columns.push(this.columnData[0])
    },
    initTe () {
      if (this.telecomOperator) {
        for (var i = 0; i < this.teleOptions.length; i++) {
          for (var j = 0; j < this.teleOptions[i].children.length; j++) {
            const item = this.teleOptions[i].children[j]
            if (item.value == this.telecomOperator) {
              this.teleDefa = [this.teleOptions[i].value, item.value]
              return
            }
          }
        }
        this.teleDefa = []
      }
    },
    changeAuxVol (val) {
      console.log('第二路电压', val)
      this.editBasicinfo.auxVoltageSupport = val ? true : false
      this.editBasicinfo.halfV = val ? true : false
      this.warnSetInfo.halfVShow = val ? true : false
    },
    changeCompany (id) {
      console.log(id)
      const obj = this.companyOption.find(item => item.companyId == id)
      // console.log(obj)
      if (obj) {
        this.dialogObj.ownCompany = obj.companyName
      }
    },
    /*
      value：值  name:属性名  bet1,bet2：取值范围 needCheck：是否需要校验 initVal：初始值
      negative：true时，校验可为负数，false则只能正数
      返回值：false通过校验   true有错误不通过校验
    */
    checkIntBet (value, name, bet1, bet2, needCheck, initVal, negative) { // 正整数
      var errorP = ''
      if ((value && value.length == 0) || (!value && value != 0)) {
        this.checkObj[name] = true
        errorP = this.$t('lease.Cannotbeblanked2')
      } else {
        if (negative && !/^[+]{0,1}(\d+)$/.test(value) && !/^[+,-]{0,1}(\d+)$/.test(value)) {
          // console.log(negative,/^[+]{0,1}(\d+)$/.test(value),/^[+,-]{0,1}(\d+)$/.test(value))
          this.checkObj[name] = true
          errorP = '请输入'+ bet1 + '~' + bet2 +'的整数'
        } else if (!negative && !/^[+]{0,1}(\d+)$/.test(value)) {
          this.checkObj[name] = true
          errorP = this.$t('sim.enterInt')
        } else if (value < bet1 || value > bet2) {
          this.checkObj[name] = true
          errorP = '请输入'+ bet1 + '~' + bet2 +'的整数'
        } else {
          this.checkObj[name] = false
          errorP = ''
        }
      }
      this.checkObj[name + 'needCheck'] = needCheck
      if (this.checkObj[name] && !needCheck) { // 值错误，但未选中，不需要校验
        this.checkObj[name + 'initVal'] = initVal
        if (name == 'halfVol') {
          if (this.editBasicinfo.batterySystemVolt >= 80) {
            this.checkObj[name + 'initVal'] = 60
          } else if (this.editBasicinfo.batterySystemVolt >= 48) {
            this.checkObj[name + 'initVal'] = 100
          } else if (this.editBasicinfo.batterySystemVolt >= 36) {
            this.checkObj[name + 'initVal'] = 150
          } else {
            this.checkObj[name + 'initVal'] = 200
          }
        }
        return ''
      } else {
        return errorP
      }
    },
    checkDigitBet (value, name, bet1, bet2, needCheck, initVal) { // 正整数或者2位小数
      var errorP = ''
      if (!value && value != 0) {
        this.checkObj[name] = true
        errorP = this.$t('lease.Cannotbeblanked2')
      } else {
        if (!/(^[0-9]{1,}$)|(^[0-9]{0,}[\.]{1}[0-9]{1,2}$)/.test(value) || (Number(value) * 100 < bet1 * 100 || Number(value) * 100 > bet2 * 100)) {
          this.checkObj[name] = true
          errorP = '请输入'+ bet1 + '~' + bet2 +'的整数或2位小数'
        } else {
          this.checkObj[name] = false
          errorP = ''
        }
      }
      this.checkObj[name + 'needCheck'] = needCheck
      if (this.checkObj[name] && !needCheck) { // 值错误，但未选中，不需要校验
        this.checkObj[name + 'initVal'] = initVal
        if (name == 'maxV' || name == 'minV' || name == 'lowVolLevel2' || name == 'lowVolLevel3' || name == 'recoveryVoltage') {
          this.checkObj[name + 'initVal'] = (initVal * this.editBasicinfo.batterySystemVolt).toFixed(2)
        }
        return ''
      } else {
        return errorP
      }
    },
    voltageFn (voltagePercentage, val, num) { // 百分比=》显示的电压    电压、设置的电压百分比、默认的电压百分比、保留num位小数
      const voltage = this.editBasicinfo.batterySystemVolt ? this.editBasicinfo.batterySystemVolt : 24
      if (voltagePercentage > 50) {
        voltagePercentage = voltagePercentage ? Number(voltagePercentage / 100) : val
        return (voltage * voltagePercentage).toFixed(num)
      }
      return (voltage * val).toFixed(num)
    },
    voltageToPercentage (voltage, num) { // 显示的电压=》百分比     电压、设置的电压百分比、默认的电压百分比、保留num位小数
      const voltagePercentage = Number(voltage) / Number(this.editBasicinfo.batterySystemVolt)
      return parseFloat((voltagePercentage * 100).toFixed(num))
    },
    getSelectedItem (allSelectKeyArr) {
      console.log(allSelectKeyArr)
      this.statusSwitches = allSelectKeyArr
    },
    getSelectedItem2 (allSelectKeyArr, allSelectLabelArr) {
      console.log('getSelectedItem2:this.allSelectKeyArr', allSelectKeyArr)
      console.log('getSelectedItem2:this.allSelectLabelArr', allSelectLabelArr)
      this.checkKeyList = allSelectKeyArr
      this.checkLabelList = allSelectLabelArr
    },
    temUnit () {
      // var temType = this.$store.state.temType || 'ssd'
      // if (temType != 'ssd') { // 华氏度
      //   return '℉'
      // } else {
      return '℃'
      // }
    },
    getSoftHardV () { // 获取软硬件版本
      listDeviceVersion().then(res => {
        console.log('获取软硬件版本', res)
        if (res.resultCode == 1001) {
          this.softHardVOptions = []
          var arr = res.resultModel || []
          arr.forEach((v, i) => {
            this.softHardVOptions.push({
              value: v.deviceType,
              label: v.deviceType,
              children: []
            })
            v.hardware.forEach((m, mi) => {
              this.softHardVOptions[i].children.push({
                value: m.hardwareVersion,
                label: m.hardwareVersion,
                children: []
              })
              m.softwareVersion.forEach(n => {
                this.softHardVOptions[i].children[mi].children.push({
                  value: n.toString(),
                  label: 'V' + n
                })
              })
            })
          })
          if (this.dialogObj.deviceType && this.dialogObj.hardwareVersion && this.dialogObj.softwareVersion) {
            this.softHardV1 = []
            this.softHardV1.push(this.dialogObj.deviceType, this.dialogObj.hardwareVersion, this.dialogObj.softwareVersion)
          }
          //  else if (arr.length) {
          //   this.softHardV1 = ['YHUB', 'YHUB12', '253']
          // }
          console.log('this.softHardVOptions', this.softHardVOptions)
        }
      })
    },
    softHardVChange () {
      console.log('softHardV', this.softHardV1)
      if (this.softHardV1.length > 0) {
        this.dialogObj.deviceType = this.softHardV1[0]
        this.dialogObj.hardwareVersion = this.softHardV1[1]
        this.dialogObj.softwareVersion = this.softHardV1[2]
        this.isShowSoftHardVWarning = false
      } else {
        this.isShowSoftHardVWarning = true
      }
    },
    _canFunctionList () {
      canFunctionList().then((res) => {
        this.canOptions = res.resultModel
      })
    },
    warnDataFn (obj) { // 处理警告设置的值
      for (var attr in obj) {
        this.warnSetInfo[attr] = obj[attr]
        // if (attr == 'minTemp' || attr == 'maxTemp' || attr == 'maxTemp2' || attr == 'maxTemp3' || attr == 'maxTemp4') {
        //   this.warnSetInfo[attr] = temChange(obj[attr])
        // }
      }
      this.warnSetInfo.halfVShow = !!((this.editBasicinfo.voltageCollection2 == 2 && this.editBasicinfo.halfV))
      this.warnSetInfo.waterLevelShow = this.editBasicinfo.supportWaterlevel != 0
      // 电池维护
      if (this.warnSetInfo.batteryMaintenanceType == 2) {
        this.dianchiVal2 = this.warnSetInfo.batteryMaintenanceValue
      } else {
        this.dianchiVal1 = this.warnSetInfo.batteryMaintenanceValue ? this.warnSetInfo.batteryMaintenanceValue : 1
      }
      // console.log('warnDataFn：this.warnSetInfo', obj)
      // this.socChecked = this.warnSetInfo.socSwitch == 1
      // this.temChecked = this.warnSetInfo.tempSwitch == 1
      this.voltChecked = this.warnSetInfo.voltageSwitch == 1
      this.netChecked = this.warnSetInfo.netSwitch == 1
      this.volProtectChecked = this.warnSetInfo.volProtectSwitch == 1
      this.linchongChecked = this.warnSetInfo.fullChargeRequestSwitch == 1
      this.chargeDisChecked = this.warnSetInfo.chargingDischargingRateSwitch == 1
      this.cheliangChecked = this.warnSetInfo.vehicleMaintenanceSwitch == 1
      this.dianchiChecked = this.warnSetInfo.batteryMaintenanceSwitch == 1
      this.waterChecked = this.warnSetInfo.supportWaterLevel == 1
      this.halfvChecked = this.warnSetInfo.halfVolSwitch == 1
      this.warnSetInfo.chargeCurrentSwitch = this.warnSetInfo.chargeCurrentSwitch == 1
      this.warnSetInfo.dischargeCurrentSwitch = this.warnSetInfo.dischargeCurrentSwitch == 1
      this.warnSetInfo.warningOpen = this.warnSetInfo.warningOpen.toString()

      // this.initWarningSettings = JSON.parse(JSON.stringify(this.warnSetInfo))

      // console.log('this.editBasicinfo.batterySystemVolt--warnDataFn--', this.warnSetInfo)
      // console.log('this.editBasicinfo.batterySystemVolt--obj--', obj)
      this.changeBatteryV(false)
      this.changeBatteryAh(false)
    },
    changeHalfV () { // 半电压阈值无值时，随着电压更改半电压阈值
      if (!this.initWarningSettings.halfVol && this.editBasicinfo.batterySystemVolt) {
        if (this.editBasicinfo.batterySystemVolt >= 80) {
          this.warnSetInfo.halfVol = 60
        } else if (this.editBasicinfo.batterySystemVolt >= 48) {
          this.warnSetInfo.halfVol = 100
        } else if (this.editBasicinfo.batterySystemVolt >= 36) {
          this.warnSetInfo.halfVol = 150
        } else {
          this.warnSetInfo.halfVol = 200
        }
      }
    },
    changeBatteryV (bool = true) { // 电池电压改变
      if (this.editBasicinfo.batterySystemVolt) {
        this.warnSetInfo.minVvalue = this.getNum(this.editBasicinfo.batterySystemVolt * this.warnSetInfo.minV / 100)
        this.warnSetInfo.maxVvalue = this.getNum(this.editBasicinfo.batterySystemVolt * this.warnSetInfo.maxV / 100)
      }
      if (bool) {
        this.editBasicinfo.cell = Math.round(this.editBasicinfo.batterySystemVolt / 12)
      }
      // this.changeHalfV()
      const obj = JSON.parse(JSON.stringify(this.warnSetInfo))
      this.warnSetInfo.maxV = this.voltageFn(obj.maxV, 1.5, 2)
      this.warnSetInfo.minV = this.voltageFn(obj.minV, 0.9, 2)
      this.warnSetInfo.lowVolLevel2 = this.voltageFn(obj.lowVolLevel2, 0.86, 2)
      this.warnSetInfo.lowVolLevel3 = this.voltageFn(obj.lowVolLevel3, 0.79, 2)
      this.warnSetInfo.recoveryVoltage = this.voltageFn(obj.recoveryVoltage, 1, 2)

    },
    changeBatteryAh (bool = true) {
      if (bool) {
        var batteryAh = Number(this.editBasicinfo.batteryTotalah)
        this.warnSetInfo.chargeCurrent = batteryAh
        this.warnSetInfo.dischargeCurrent = batteryAh * 2
      }
    },
    initBatteryModel () {
      const btys = []
      this.options2.forEach(item => {
        if (item.children) {
          item.children.forEach(it => {
            btys.push(it.value)
          })
        }
      })
      const obj = btys.find(item => item.id == this.editBasicinfo.batteryId)
      const common = btys.find(item => item.id == 1)
      if (obj) {
        this.batteryCascader = obj
      } else {
        this.batteryCascader = common
      }
    },
    // 编辑时，修正容量和警告电压 
    correctValue () {
      this.editBasicinfo.batteryTotalah = Math.round(this.editBasicinfo.batteryTotalah / 100)
      this.editBasicinfo.locationStatus = this.editBasicinfo.locationStatus == 1

      let extralArr = this.decimalToBinary(this.editBasicinfo.extralFuntion, 2)
      this.editBasicinfo.moveOrbitSwitch = Boolean(extralArr[1])
      this.editBasicinfo.communication485 = Boolean(extralArr[3])
      this.editBasicinfo.auxCurrentSupport = Boolean(extralArr[4])
      this.editBasicinfo.auxVoltageSupport = Boolean(extralArr[5])

    },
    batteryModelChange (value, bool = true) { // 绑定设备弹窗--电池型号选中
      console.log('选择电池', value)
      if (!value) return
      this.batteryModelObj = value[1]
      if (!value[1].batteryAhC5) { this.disabledC5 = true } else { this.disabledC5 = false }
      this.editBasicinfo.batteryTotalah = value[1].batteryAh
      this.editBasicinfo.batteryId = value[1].id
      this.editBasicinfo.batteryBrand = value[1].batteryBrand
      this.editBasicinfo.batteryModel = value[1].batteryModel
      this.editBasicinfo.batterySystemVolt = value[1].batteryVoltage || 24
      this.isShowBatteryModelWarning = false
      this.editBasicinfo.cell = Math.round(this.editBasicinfo.batterySystemVolt / 12)

      this.changeBatteryV(bool)
      this.changeBatteryAh(bool)
    },
    initOption () { // 电池型号/品牌/设备类型--下拉框初始化
      // this.listLoading = true
      cascader().then((response) => {
        // 绑定设备弹窗--电池型号下拉框
        this.options2 = response.resultModel || []
        this.initBatteryModel()

      })
      // apn列表
      this.apnOptions = []
      apnList().then(res => {
        console.log('apn列表：', res)
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.forEach(v => {
          this.apnOptions.unshift(v.apnValue)
        })
      })
    },
    changeApn (val) {
      this.dialogObj.apn = val
    },
    changeEditC520 (val) { // 改变c5/c20
      let btyAh = 100
      if (this.batteryModelObj.batteryAh) btyAh = this.batteryModelObj.batteryAh
      if (val == 2 && this.batteryModelObj.batteryAhC5) btyAh = this.batteryModelObj.batteryAhC5
      if (val == 3 && this.batteryModelObj.batteryAhC6) btyAh = this.batteryModelObj.batteryAhC6
      this.editBasicinfo.batteryTotalah = btyAh
    },
    hallSensorRangeChange (val) {
      const type = this.editBasicinfo.sensorType
      if (val == 1 && type == 1) this.dialogObj.mainCurrentSensorType = 1
      if (val == 1 && type == 2) this.dialogObj.mainCurrentSensorType = 3
      if (val == 2) this.dialogObj.mainCurrentSensorType = 2
      if (val == 3) this.dialogObj.mainCurrentSensorType = 4
    },
    sensorTypeChange (val) { // 绑定设备弹窗--电流计类型选中
      if (val == 1) {
        this.dialogObj.mainCurrentSensorType = 1
        this.sensorRangeOptions[1].show = false
        this.sensorRangeOptions[2].show = true
      }
      if (val == 2) {
        this.dialogObj.mainCurrentSensorType = 3
        this.sensorRangeOptions[1].show = true
        this.sensorRangeOptions[2].show = false
      }
      this.editBasicinfo.hallSensorRange = 1
    },
    samplingModeChange () {
      this.$forceUpdate()
      this.checkIntBet(this.editBasicinfo.voltChangeRate, 'voltChangeRate', 100, 1000, this.editBasicinfo.samplingMode == 1 ? 1 : 0, 300)
      this.checkIntBet(this.editBasicinfo.samplingRate, 'samplingRate', 6, 600, this.editBasicinfo.samplingMode == 2 ? 1 : 0, 480)
    },
    // changeMotionTrack (val) { // 改变运动轨迹
    //   this.$forceUpdate()
    //   if (val == 1) this.checkObj.locationSample = true; this.editBasicinfo.locationSample = this.initSetObj.locationSample
    // },
    changeHalfvSwitch () {
      this.checkIntBet(this.halfVol, 'halfVol', 10, 10000, (this.halfvChecked && this.editBasicinfo.halfV) ? 1 : 0, 10)
      this.checkIntBet(this.halfVoltageDuration, 'halfVoltageDuration', 5, 7200, (this.halfvChecked && this.editBasicinfo.halfV) ? 1 : 0, 15)
    },
    changeSocChecked () {
      this.checkIntBet(this.minSoc, 'minSoc', 0, 100, this.warnSetInfo.socSwitch, 30)
      this.checkIntBet(this.maxSoc, 'maxSoc', 0, 100, this.warnSetInfo.socSwitch, 80)
    },
    changTemSwitch () {
      this.checkIntBet(this.minTemp, 'minTemp', -40, 125, this.warnSetInfo.tempSwitch, 0, 'fu')
      this.checkIntBet(this.maxTemp, 'maxTemp', 0, 125, this.warnSetInfo.tempSwitch, 50)
      this.checkIntBet(this.maxTemp2, 'maxTemp2', 0, 125, this.warnSetInfo.tempSwitch, 55)
      this.checkIntBet(this.maxTemp3, 'maxTemp3', 0, 125, this.warnSetInfo.tempSwitch, 60)
      this.checkIntBet(this.errTemp, 'errTemp', 0, 125, this.warnSetInfo.tempSwitch, 101)
    },
    changeVolCheck () {
      this.checkDigitBet(this.warnSetInfo.maxV, 'maxV', 12, 120, this.voltChecked, 1.48)
      this.checkDigitBet(this.warnSetInfo.minV, 'minV', 12, 120, this.voltChecked || this.volProtectChecked, 0.9)
      this.checkDigitBet(this.warnSetInfo.lowVolLevel2, 'lowVolLevel2', 12, 120, this.voltChecked || this.volProtectChecked, 0.86)
      this.checkDigitBet(this.warnSetInfo.lowVolLevel3, 'lowVolLevel3', 12, 120, this.voltChecked || this.volProtectChecked, 0.79)
      this.checkDigitBet(this.warnSetInfo.recoveryVoltage, 'recoveryVoltage', 12, 120, this.voltChecked || this.volProtectChecked, 1)
      this.checkIntBet(this.warnSetInfo.voltageDuration, 'recoveryVoltage', 5, 7200, this.voltChecked || this.volProtectChecked, 15)
    },
    changeNetChecked () {
      this.checkIntBet(this.warnSetInfo.offLine, 'offLine', 1, 10000, this.netChecked, 168)
    },
    changeWaterSwitch () {
      this.checkIntBet(this.waterDuration, 'waterDuration', 1, 10000, this.waterChecked, 30)
    },
    changeChargeCurrent () {
      this.checkIntBet(this.chargeCurrent, 'chargeCurrent', 1, 1000, (this.chargeCurrentSwitch == 1) ? 1 : 0, this.editBasicinfo.batteryTotalah)
      this.checkIntBet(this.currentDuration, 'currentDuration', 5, 7200, (this.chargeCurrentSwitch == 1 || this.dischargeCurrentSwitch == 1) ? 1 : 0, 15)
    },
    changeDischargeCurrent () {
      this.checkIntBet(this.dischargeCurrent, 'dischargeCurrent', 1, 1000, (this.dischargeCurrentSwitch == 1) ? 1 : 0, this.editBasicinfo.batteryTotalah * 2)
      this.checkIntBet(this.currentDuration, 'currentDuration', 5, 7200, (this.chargeCurrentSwitch == 1 || this.dischargeCurrentSwitch == 1) ? 1 : 0, 15)
    },
    changeLinchongSwitch () {
      this.checkIntBet(this.intermediateChargeTimes, 'intermediateChargeTimes', 5, 1000)
    },
    changeChargeDisCheckedSwitch () {
      this.checkIntBet(this.chargingDischargingRateValue, 'chargingDischargingRateValue', 120, 10000, this.chargeDisChecked, 200)
    },
    changeDianchiSwitch () {
      this.checkIntBet(this.dianchiVal2, 'dianchiVal2', 1, this.editBasicinfo.batteryAh * 100, (this.dianchiChecked && this.batteryMaintenanceType == 2) ? 1 : 0, this.form.batteryAh * 10)
    },
    switchhourMeterStatus (val) {
      this.checkDigitBet(this.editBasicinfo.openIgnitionVol, 'openIgnitionVol', 0.5, 60, this.editBasicinfo.hourMeterStatus, 0.5)
      this.checkDigitBet(this.editBasicinfo.workHourmeterVol, 'workHourmeterVol', 0.5, 60, this.editBasicinfo.hourMeterStatus, 7)
    },
    bulrInput (val, attr) { // 电压采样变化率/采样周期--失焦
      var vRate = this.editBasicinfo.voltChangeRate
      var sRate = this.editBasicinfo.samplingRate
      this.isShowMustIntWarn = false
      if (this.editBasicinfo.samplingMode == 1) {
        if (vRate.length == 0) {
          this.isShowMustIntWarn = true
          this.editBasicinfo.warnMsg = this.$t('AllDevices.VSampChange') + ' ' + this.$t('lease.Cannotbeblanked2')
        } else if (vRate < 100 || vRate > 1000) { // 取值范围只能是100-1000
          this.isShowMustIntWarn = true
          var msg = this.$t('AllDevices.mustBetween').replace('$1', this.$t('AllDevices.VSampChange'))
          msg = msg.replace('$2', '100-1000')
          this.editBasicinfo.warnMsg = msg
        } else if (!/^[+]{0,1}(\d+)$/.test(vRate)) { // 必须为整数
          this.isShowMustIntWarn = true
          this.editBasicinfo.warnMsg = this.$t('AllDevices.VSampChange') + ' ' + this.$t('AllDevices.mustInt')
        }
      } else if (this.editBasicinfo.samplingMode == 2) {
        if (sRate.length == 0) {
          this.isShowMustIntWarn = true
          this.editBasicinfo.warnMsg = this.$t('AllDevices.sampPeriod') + ' ' + this.$t('lease.Cannotbeblanked2')
        } else if (sRate < 6 || sRate > 600) {
          this.isShowMustIntWarn = true
          var msg1 = this.$t('AllDevices.mustBetween').replace('$1', this.$t('AllDevices.sampPeriod'))
          msg1 = msg1.replace('$2', '6-600')
          this.editBasicinfo.warnMsg = msg1
        } else if (!/^[0-9][0-9]*(\.[0-9]{1,3})?$/.test(sRate)) { // 只能为整数或最多三位小数
          this.isShowMustIntWarn = true
          this.editBasicinfo.warnMsg = this.$t('AllDevices.sampPeriod') + ' ' + this.$t('AllDevices.intOrThreeDecimal')
        }
      }
    },
    changeDiaVal (val) { // 订单配置变化
      this.$forceUpdate()
      switch (val) {
        case 'waterLevelSocket': this.editBasicinfo.supportWaterlevel = this.dialogObj.waterLevelSocket == 0 ? 0 : 1; break
        case 'interLockSocket': this.editBasicinfo.supportRelaycontrol = this.dialogObj.interLockSocket == 0 ? 0 : 1; break
        case 'auxBatteryCurrent': this.editBasicinfo.currentCollection2 = this.dialogObj.auxBatteryCurrent == 0 ? 1 : 2; break
        case 'auxBatteryVoltage': this.editBasicinfo.voltageCollection2 = this.dialogObj.auxBatteryVoltage == 0 ? 1 : 2; break
        case 'rs485Socket': this.editBasicinfo.communication485 = this.dialogObj.rs485Socket == 0 ? 1 : 2; break
        
      }
    },
    submitPop (isNew = 0) { // 弹窗--提交
      // console.log('提交', this.dialogObj)
      // console.log('提交editBasicinfo', this.editBasicinfo)
      // console.log('提交warnSetInfo', this.warnSetInfo)
      if (isNew == 1) {
        console.log('新建同款')
      }
      
      this.dialogObj.productModelCustomer = JSON.stringify({
        serverSelection: this.serverSelection,
        telecomOperator: this.telecomOperator
      })

      var errorMsg = ''// 错误提示语
      var allTrue = true
      /* this.checkObj[v]:false  校验不通过  this.checkObj[v+'needCheck']:是否需要校验*/
      this.checkVal1.forEach(v => {
        if (this.checkObj[v] && this.checkObj[v + 'needCheck']) {
          allTrue = false
          errorMsg = '基本设置中有参数错误，请检查'
          this.$emit('setScrollIndex', 0)
        } else if (this.checkObj[v] && !this.checkObj[v + 'needCheck']) {
          this.dialogObj[v] = this.checkObj[v + 'initVal']
        }
      })
      console.log(allTrue)
      if (allTrue) {
        this.checkVal2.forEach(v => {
          if (this.checkObj[v] && this.checkObj[v + 'needCheck']) {
            allTrue = false
            errorMsg = '定制功能中有参数错误，请检查'
            this.$emit('setScrollIndex', 1)
          } else if (this.checkObj[v] && !this.checkObj[v + 'needCheck']) {
            this.editBasicinfo[v] = this.checkObj[v + 'initVal']
          }
        })
      }
      console.log(allTrue)
      if (allTrue) {
        this.checkVal3.forEach(v => {
          if (this.checkObj[v] && this.checkObj[v + 'needCheck'] && this.warnSetInfo.warningOpen == 1) {
            allTrue = false
            errorMsg = '警告设置中有参数错误，请检查'
            this.$emit('setScrollIndex', 2)
          } else if (this.checkObj[v] && !this.checkObj[v + 'needCheck']) {
            this.warnSetInfo[v] = this.checkObj[v + 'initVal']
          }
        })
      }
      console.log(allTrue)
      this.checkSoftHard()
      if (this.isShowSoftHardVWarning) return
      if (!allTrue) { // 校验输入正确与否：错误时
        this.$message({
          message: errorMsg,
          showClose: true,
          type: 'error'
        })
        return null
      } else {
        // return
        var a = false
        var b = true
        var c = false
        if (this.editBasicinfo.nodeID < 1 || this.editBasicinfo.nodeID > 127) return
        this.$refs.configPop.validate((valid) => {
          if (valid && !this.isShowMustIntWarn) {
            a = true
          } else {
            a = false
            this.$message({
              type: 'error',
              message: this.$t('adminView.pleaseCheck')
            })
            return
          }
        })
        
        this.$refs.productPop.validate((valid) => {
          if (valid) {
            c = true
          } else {
            c = false
            this.$message({
              type: 'error',
              message: '基本设置中有参数错误，请检查'
            })
            return
          }
        })
        if (this.editBasicinfo.moveOrbitSwitch && this.isShowLocationSampleWarn) return
        // console.log('aaaaa', a)
        // console.log(b)
        // console.log(c)

        if (a && b && c) {

          let yhubConfig1 = JSON.parse(JSON.stringify(this.editBasicinfo))
          if (isNew == 1) {
            delete yhubConfig1.id
          }
          yhubConfig1.auxCurrentSupport = Boolean(this.dialogObj.auxBatteryCurrent)
          yhubConfig1.auxVoltageSupport = Boolean(this.dialogObj.auxBatteryVoltage)
          const rate = this.editBasicinfo.samplingRate
          yhubConfig1.samplingRate = rate * 1000
          const total = this.editBasicinfo.batteryTotalah
          yhubConfig1.batteryTotalah = total * 100
          // yhubConfig1.nominalCapacity = this.editBasicinfo.c520 ? this.editBasicinfo.c520 : 1
          yhubConfig1.updateBy = this.$store.state.userInfo.userLoginName
          yhubConfig1.halfV = this.editBasicinfo.halfV ? 1 : 0
          yhubConfig1.showAvailableTime = this.editBasicinfo.showAvailableTime ? 1 : 0
          yhubConfig1.hourMeterStatus = this.editBasicinfo.hourMeterStatus ? 1 : 0
          yhubConfig1.locationStatus = this.editBasicinfo.locationStatus ? 1 : 0

          let extralArr = this.decimalToBinary(yhubConfig1.extralFuntion, 2)
          extralArr[1] = yhubConfig1.moveOrbitSwitch ? 1 : 0
          extralArr[3] = yhubConfig1.communication485 ? 1 : 0
          extralArr[4] = yhubConfig1.auxCurrentSupport ? 1 : 0
          extralArr[5] = yhubConfig1.auxVoltageSupport ? 1 : 0
          yhubConfig1.extralFuntion = Number(this.binaryToDecimal(extralArr))

          yhubConfig1.usageSettings = JSON.stringify({
            startCharging: 1,
            fullCharge: 1,
            batteryUse: 1
          })

          console.log('高级配置', yhubConfig1)

          // return
          // for (var attr in param) {
          //   if (attr.slice(-2) == 'Zh') { delete param[attr] }
          // }
          if (this.warnSetInfo.batteryMaintenanceType == 2) {
            this.warnSetInfo.batteryMaintenanceValue = this.dianchiVal2
          } else {
            this.warnSetInfo.batteryMaintenanceValue = this.dianchiVal1
          }

          console.log(this.warnSetInfo.batteryMaintenanceValue)

          let warnSets = JSON.parse(JSON.stringify(this.warnSetInfo))
          // warnSets.socSwitch = this.socChecked ? 1 : 0
          // warnSets.tempSwitch = this.temChecked ? 1 : 0
          warnSets.voltageSwitch = this.voltChecked ? 1 : 0
          warnSets.netSwitch = this.netChecked ? 1 : 0
          warnSets.volProtectSwitch = this.volProtectChecked ? 1 : 0

          warnSets.fullChargeRequestSwitch = this.linchongChecked ? 1 : 0
          warnSets.chargingDischargingRateSwitch = this.chargeDisChecked ? 1 : 0
          warnSets.vehicleMaintenanceSwitch = this.cheliangChecked ? 1 : 0
          warnSets.batteryMaintenanceSwitch = this.dianchiChecked ? 1 : 0
          warnSets.halfVolSwitch = this.halfvChecked ? 1 : 0
          warnSets.supportWaterLevel = this.waterChecked ? 1 : 0

          for (var attr in this.warnSetInfo) {
            // if (attr == 'minTemp' || attr == 'maxTemp' || attr == 'maxTemp2' || attr == 'maxTemp3' || attr == 'maxTemp4') {
            //   warnSets[attr] = temHsdToSsd(this.warnSetInfo[attr])
            // }
            if (attr == 'maxV' || attr == 'minV' || attr == 'lowVolLevel2' || attr == 'lowVolLevel3' || attr == 'recoveryVoltage') {
              warnSets[attr] = this.voltageToPercentage(this.warnSetInfo[attr], 2)
            }
          }

          console.log('警告配置', warnSets)

          yhubConfig1.warningSettings = JSON.stringify(warnSets)
          this.dialogObj.yhubConfigAdmin = yhubConfig1

          console.log('this.dialogObj提交成功', this.dialogObj)

          if (this.isAdd || isNew == 1) { // 新增
            this.dialogObj.productId = ''
            add(this.dialogObj).then(res => {
              if (res.resultCode === 1001) {
                this.$message({
                  type: 'success',
                  message: this.$t('lease.Succeed')
                })
                this.goBack()
              }
            })
          } else {
            updateById(this.dialogObj).then(respone => {
              if (respone.resultCode === 1001) {
                this.$message({
                  type: 'success',
                  message: this.$t('lease.Succeed')
                })
                this.goBack()
              }
            })
          }
        }
      }
    },
    checkSoftHard (val) { // 校验软硬件版本是否正确
      if (!this.softHardV1 || !this.softHardV1.length) {
        if (!val) this.isShowSoftHardVWarning = true
        return
      }
      this.isShowSoftHardVWarning = true
      this.softHardVOptions.forEach(v => {
        if (v.value == this.softHardV1[0]) {
          v.children.forEach(m => {
            if (m.value == this.softHardV1[1]) {
              m.children.forEach(n => {
                if (n.value == this.softHardV1[2]) {
                  this.isShowSoftHardVWarning = false
                }
              })
            }
          })
        }
      })
    },
    goBack () { // 返回订单列表页
      var routeData = this.$router.resolve({
        path: '/product/productIndex',
        query: {}
      })
      window.open(routeData.href, '_self')
    },
    inputBlur (attr, bfbOrVal, num) {
      var val = this.warnSetInfo[attr]
      if (!val) {
        this['vEnterWrong' + num] = true
        this['vEnterWrongP' + num] = 'lease.Cannotbeblanked2'
        this.errorV(attr)// 电压输入错误，值清空
      } else if (attr == 'offLine' && !(/^[+]{0,1}(\d+)$/.test(val))) {
        this['vEnterWrong' + num] = true
        this['vEnterWrongP' + num] = 'AllDevices.mustInt'
        this.warnSetInfo.offLine = null
      } else if (!(/^[+,-]{0,1}[0-9][0-9]*(\.[0-9]{1,2})?$/.test(val))) { // 校验整数或小数(允许1-10位小数)
        this['vEnterWrong' + num] = true
        this['vEnterWrongP' + num] = 'warningSet.enterNumber'
        this.errorV(attr)// 电压输入错误，值清空
      } else {
        this['vEnterWrong' + num] = false
        if (attr != 'offLine' && this.editBasicinfo.batterySystemVolt && this.editBasicinfo.batterySystemVolt != '--') {
          if (bfbOrVal == 'value') this.warnSetInfo[attr.slice(0, -5)] = this.getNum(this.warnSetInfo[attr] / this.editBasicinfo.batterySystemVolt * 100)
          if (bfbOrVal == 'bfb') this.warnSetInfo[attr + 'value'] = this.getNum(this.warnSetInfo[attr] / 100 * this.editBasicinfo.batterySystemVolt)
          if (this.warnSetInfo.minVvalue >= this.editBasicinfo.batterySystemVolt) {
            this['vEnterWrong' + num] = true
            this['vEnterWrongP' + num] = 'warningSet.underVoltage'
            this.errorV(attr)// 电压输入错误，值清空
          }
          if (this.warnSetInfo.maxVvalue <= this.editBasicinfo.batterySystemVolt) {
            this['vEnterWrong' + num] = true
            this['vEnterWrongP' + num] = 'warningSet.overVoltage'
            this.errorV(attr)// 电压输入错误，值清空
          }
        }
      }
    },
    errorV (attr) { // 电压输入错误，值清空
      if (attr.indexOf('minV') > -1) this.warnSetInfo.minVvalue = this.warnSetInfo.minV = null
      if (attr.indexOf('maxV') > -1) this.warnSetInfo.maxVvalue = this.warnSetInfo.maxV = null
    },
    change (e, val) {
      this.$forceUpdate()
      if (val == 'locationSample') {
        this.isShowLocationSampleWarn = !!((!this.editBasicinfo.locationSample || this.editBasicinfo.locationSample < 30))
      }
    },
    querySearch (queryString, cb) { // 产品型号--带输入建议的输入框
      var restaurants = prodModels
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      cb(results)
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect (item) {
      console.log(item)
    },
    getNum (num) {
      num = (Math.round(num * 100) / 100).toFixed(2)
      return num
    },
    decimalToBinary (num, digits) { // 十进制转二进制  digits:代表传过来的是几位数，避免用<10判断出错，如：01 本应该转成8位，却转成了4位
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (!digits || digits == 1) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
        // } else if (myNum >= 10 && myNum < 100) {
      } else if (digits == 2) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    },
    binaryToDecimal (arr) { // 二进制转十进制
      var a = []
      var allZero = arr.every(m => { return m == 0 })
      if (allZero) {
        c = 0
      } else {
        arr.forEach((v, i) => {
          var end = arr.slice(i)
          // 如果v=1,并且v后面没有1了，则a等于v及其之前的数。如：arr=[0,1,1,1,1,0,0,0] => a=[0,1,1,1,1]
          if (v == 1 && end.indexOf(1) > -1) a = arr.slice(0, i + 1)
        })
        var b = a.reverse().join('')
        var c = parseInt(b, 2).toString(10)
      }
      return c
    },
    netModuleChange (e) {
      this.noNetModule = (e == '')
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  background-color: #fff;
  padding: 20px;
}

.titleP {
  color: #1890ff;
  position: relative;
  font-size: 20px;
  margin: 20px 0;
}

.el-form-item {
  margin-bottom: 12px;
}
.lastRadio {
  margin-right: 0;
}
.el-form-item__content {
  position: relative;
}
.attrDiv {
  position: relative;
  margin-bottom: 10px;
}

.el-tabs__header {
  margin: 0;
}
.el-tabs {
  padding-left: 5px;
  // border-left:1px solid #DCDFE6;
}
.el-form .el-col:nth-of-type(1) {
  margin-top: 15px;
}
.noConfigP {
  display: inline-block;
  color: red;
  position: absolute;
  font-size: 12px;
  left: 5px;
  top: 5px;
}

#configPop {
  .noConfig.titleP {
    margin: 15px 20px;
    &::before {
      top: 10px;
    }
  }
}
.mustIntWarn {
  position: absolute;
  color: #ff4949;
  font-size: 12px;
  line-height: 1;
  padding-top: 0px;
  z-index: 2;
}

.voltageDiv1,
.offLineDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .el-input {
    width: 70% !important;
  }
  .el-radio {
    line-height: inherit;
  }
}
.warnPClass {
  color: #ff4949;
  display: inline-block;
  font-size: 12px;
}
.itemBox {
  position: relative;
  border-bottom: 1px solid #cccccc26;
  padding: 10px 0;
  font-size: 14px;
  .labelDiv {
    font-size: 16px;
    margin-bottom: 10px;
  }
}
.redWarningFont {
  padding: 0;
}

.item_box {
  position: relative;
  padding: 10px 0;
}
.formErrorP {
  // position: absolute;
  // bottom: -20px;
  // left: 0;
  font-size: 12px;
  color: #f56c6c;
  text-align: left;
}
</style>
